import React, { useState, useEffect } from 'react';
import GlobalSearch from '../../Components/GlobalSearch';
import RedesignSearchField from '../shared/RedesignSearchField';
import RedesignNavSections from '../shared/RedesignNavSections';

const NavRedesign = () => {
    const [globalSearchOpen, setGlobalSearchOpen] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setGlobalSearchOpen(true);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <div className="grow-0 pt-2 pr-2 max-h-screen min-h-screen print:hidden dark:text-slate-100 dark:fill-slate-100">
            <nav className="my-2 fixed mx-auto h-[calc(100vh-2rem)] overflow-y-auto">

                <RedesignSearchField onOpen={() => setGlobalSearchOpen(true)} />

                <RedesignNavSections />

                <p>&nbsp;</p>
            </nav>

            <div className="w-[200px]">&nbsp;</div>

            <GlobalSearch isOpen={globalSearchOpen} setIsOpen={() => setGlobalSearchOpen(false)} />
        </div>
    );
};

export default NavRedesign;
